// --------------------------------------------------------
//MEDICAL RECORD - MedicalRecord
// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------

import React, { useEffect, useState } from "react";
import ContainerWithSidebar from "../../components/UI/containerWithSidebar/ContainerWithSidebar";
import {
  GeneralContainer,
  H1,
  TextLink,
} from "../../components/UI/generalLayout/Layout.styled";

import Colors from "../../constants/Colors";
import {
  TextualData,
  PersonalData,
  PatientData,
  Img,
  Menu,
  ButtonMenu,
  Content,
  ContainerTopics,
} from "./MedicalRecord.styled";

import useResponsiveInfo from "../../hooks/useResponsiveInfo";

//
import avatar from "../../assets/imgs/avatar.jpg";
import InputInformation from "./components/InputInformation";
import { Spacer } from "../../components/UI/spacer/spacer";
import AttendanceRecord from "./components/attendanceRecord/AttendanceRecord";
import { useLocation, useNavigate } from "react-router";
import AttendanceCareLines from "./components/careLines/AttendanceCareLines";
import Allergies from "./components/allergies/Allergies";
import ExamsTab from "./components/exams/ExamsTab";
import OccupHealthTab from "./components/occupationalHealth/OccupHealthTab";
import Person from "../../models/core/userRole/Person";
import moment from "moment-timezone";
import useFetchPhoto from "../../hooks/useFetchPhoto";
import { getDescricaoByCodigoGender } from "../../enums/Genders";
import { Paths } from "../../enums/Paths";
import { getMenuItemsByRole } from "../../helpers/HelperFunctions";
import { NavegacaoService } from "../../core/http/service/NavegacaoService";
import QuestionnaireAnswers from "./components/questionnaireAnswers/QuestionnaireAnswers";
import ListProblem from "./components/listProblem/ListProblem";
import { useAppDispatch } from "../..";
import * as medicalRecordAction from "../../store/actions/medicalRecord";
import { useSelector } from "react-redux";
import { PersonAllergieService } from "../../core/http/service/PersonAllergieService";
import { PersonService } from "../../core/http/service/PersonService";
import { BiLinkExternal } from "react-icons/bi";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import QuestionnaireEletronic from "./components/questionnaireEletronic/QuestionnaireEletronic";
import { AppointmentService } from "../../core/http/service/AppointmentService";
import TermosTab from "./components/termos/TermosTab";
import ClinicFrameConfiguracaoService from "../../core/http/service/ClinicFrameConfiguracaoService";

// --------------------------------------------------------
// MEDICAL RECORD INTERFACE
// --------------------------------------------------------
/**
 * A component that renders a Screen.
 *
 * @param props Properties
 * @param props.route The route
 * @param props.navigation The navigator
 * @returns The component JSX.
 */

interface IMedicalRecord {
  name?: string;
}

function MedicalRecord({ name }: IMedicalRecord): JSX.Element {
  // --------------------------------------------------------
  // MEDICAL RECORD PRIVATE DECLARATIONS
  // --------------------------------------------------------

  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { isMobile } = useResponsiveInfo();
  const { state } = useLocation();
  const { pessoa, agendamento }: any = state ?? new Person();
  const [optionMenu, setOptionMenu] = useState<number>(
    useSelector((state: any) => state.medicalRecord.abaActive)
  );
  const [ultimoProntuario, setUltimoProntuario] = useState<any>({});
  const [allergiesColor, setAllergiesColor] = useState("");
  const [useClinicFrame, setUseClinicFrame] = useState(false);
  const [clinicFrameConfig, setClinicFrameConfig] = useState<any>(null);
  const [medicoFamiliaNome, setMedicoFamiliaNome] = useState<string | undefined>();
  const { currentProfile, dependenteProfile }: any = useSelector((state: any) => state.login);
  const acessoProntuario = useSelector((state: any) => state.person.acessoProntuario)

  const fetchAllergies = () => {
    const service = new PersonAllergieService();
    const serviceProntuario = new AppointmentService();
    if (pessoa) {

      serviceProntuario.getLastAppointment(pessoa.idPessoa).then((data: any) => {
        setUltimoProntuario(data)
      });

      service
        .getAllergiesPerson({
          id: pessoa.idPessoa,
          alergeno: "",
        })
        .then(({ data: { data } }) => {
          if (data.length > 0) {
            setAllergiesColor(Colors.cancel);
          } else {
            setAllergiesColor("");
          }
        });
    }
  };

  useEffect(() => {
    const savedCompanyStr = localStorage.getItem('currentCompany');
    if (savedCompanyStr) {
      const savedCompany = JSON.parse(savedCompanyStr);
      setUseClinicFrame(savedCompany.usaClinicFrame === true);
      
      if (savedCompany.usaClinicFrame) {
        ClinicFrameConfiguracaoService.getConfiguracao(savedCompany.id).then((resp: any) => {
            if (resp.data && resp.data.data) {
                setClinicFrameConfig(resp.data.data);
            }
        });
      }
    }
    fetchAllergies();
  }, []);

  const [isAlreadyInNavigation, setIsAlreadyInNavigation] = useState(false);
  useEffect(() => {
    const personId = agendamento?.idPessoa ?? pessoa?.idPessoa ?? pessoa?.id;
    if (personId) {
      const personService = new PersonService();
      personService
        .getMedicoFamilia(personId)
        .then(({ data: { data } }: any) => {
          setMedicoFamiliaNome(data?.nome ?? undefined);
        })
        .catch(() => {
          setMedicoFamiliaNome(undefined);
        });

      const navService = new NavegacaoService();
      navService.getAtivaPorPaciente(personId)
        .then((res: any) => {
          setIsAlreadyInNavigation(!!res?.data?.data);
        })
        .catch(() => {
          setIsAlreadyInNavigation(false);
        });
    }
  }, [pessoa?.idPessoa, pessoa?.id, agendamento?.idPessoa]);

  const userMenuItems = getMenuItemsByRole(currentProfile, !!dependenteProfile);
  const hasAccessToNavegacao =
    (userMenuItems || []).some((item: any) => item.path === Paths.PainelNavegacao) ||
    ["MED", "ENF", "ADM"].includes(currentProfile);

  const handleNavigateToNavegacao = () => {
    const personId = agendamento?.idPessoa ?? pessoa?.idPessoa ?? pessoa?.id;
    if (hasAccessToNavegacao && (pessoa?.nome || personId)) {
      navigate(Paths.PainelNavegacao, { state: { searchText: pessoa.nome, pacienteId: personId } });
    }
  };

  const [photo, setPhoto] = useState<any>();
  useFetchPhoto(pessoa.foto, setPhoto);

  const select = (option: number | undefined) => {
    return (
      <ContainerTopics isMobile={isMobile}>
        {" "}
        {contentMenu(option)}
      </ContainerTopics>
    );
  };

  const calcularIdade = (dataNascimento: any): string => {
    const hoje = moment();
    const nascimento = moment(dataNascimento, "YYYY-MM-DD");

    const anos = hoje.diff(nascimento, 'years');
    nascimento.add(anos, 'years');

    const meses = hoje.diff(nascimento, 'months');
    nascimento.add(meses, 'months');

    const dias = hoje.diff(nascimento, 'days');

    const resultado = `${anos} ano${anos !== 1 ? 's' : ''}, ${meses} ${meses !== 1 ? 'meses' : 'mês'}, ${dias} dia${dias !== 1 ? 's' : ''}`;

    return resultado;
  };


  const contentMenu = (option: number | undefined) => {
    switch (option) {
      case 1: {
        return <ListProblem pessoa={pessoa} agendamento={agendamento} />;
      }
      case 2: {
        return <AttendanceRecord pessoa={pessoa} agendamento={agendamento} />;
      }
      case 3: {
        return (
          <AttendanceCareLines pessoa={pessoa} agendamento={agendamento} />
        );
      }
      case 4: {
        return <OccupHealthTab pessoa={pessoa} agendamento={agendamento} />;
      }
      case 5: {
        return <QuestionnaireAnswers pessoa={pessoa} />;
      }
      case 6: {
        return <ExamsTab pessoa={pessoa} />;
      }
      case 7: {
        return (
          <Allergies pessoa={pessoa} setAllergiesColor={setAllergiesColor} />
        );
      }
      case 8: {
        return <QuestionnaireEletronic pessoa={pessoa} />;
      }
      case 9: {
        return <TermosTab pessoa={pessoa} agendamento={agendamento} />;
      }
      default: {
        break;
      }
    }
  };
  return (
    <ContainerWithSidebar>
      <GeneralContainer>
        <TextLink
          color={Colors.SPM600}
          onClick={() => {
            dispatch(medicalRecordAction.handleActive(1));
            //navigate(Paths.PainelConsulta);
            navigate(-1);
          }}
        >
          {"< Voltar para lista de pacientes"}
        </TextLink>

        <PatientData isMobile={isMobile}>
          <TextualData>
            {isMobile && <Img src={photo} />}
            <H1>{pessoa.nome}</H1>
            {isAlreadyInNavigation && (
              <div style={{ marginTop: 8, marginBottom: 16 }}>
                <span
                  onClick={handleNavigateToNavegacao}
                  title={hasAccessToNavegacao ? "Clique para abrir no Painel de Navegação" : ""}
                  style={{
                    border: '1px solid #DC2626',
                    backgroundColor: '#FEF2F2',
                    color: '#DC2626',
                    padding: '10px 18px',
                    borderRadius: '4px',
                    fontSize: '1rem',
                    fontWeight: 600,
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 6,
                    cursor: hasAccessToNavegacao ? 'pointer' : 'default',
                    userSelect: 'none',
                    transition: 'all 0.2s ease',
                  }}
                >
                  <InfoOutlinedIcon style={{ fontSize: '1.5rem', color: '#DC2626' }} />
                  Em Navegação
                  {hasAccessToNavegacao && (
                    <BiLinkExternal style={{ fontSize: '1.2rem', marginLeft: 4, color: '#DC2626' }} />
                  )}
                </span>
              </div>
            )}

            <PersonalData isMobile={isMobile}>
              <InputInformation
                descricao="Como gostaria de ser chamado"
                name={"gostaSerChamado"}
                value={pessoa.comoSerChamado}
              />
              <InputInformation
                descricao="Data de Nascimento"
                name={"dataNascimento"}
                value={moment(pessoa.dataNascimento, "YYYY-MM-DD").format(
                  "DD/MM/YYYY"
                )}
              />

              <InputInformation
                descricao="Idade"
                name={"idade"}
                value={calcularIdade(pessoa.dataNascimento).toString()}
              />

              <InputInformation
                descricao="CPF"
                name={"cpf"}
                value={pessoa.cpf.replace(
                  /^(\d{3})(\d{3})(\d{3})(\d{2})/,
                  "$1.$2.$3-$4"
                )}
              />
              <InputInformation
                descricao="Gênero"
                name={"genero"}
                value={pessoa.genero && pessoa.genero.length > 4 ? pessoa.genero : getDescricaoByCodigoGender(pessoa.genero)}
              />
              <InputInformation
                  descricao="Médico de família"
                  name={"medicoFamilia"}
                  value={medicoFamiliaNome ?? "Não possui"}
              />
            </PersonalData>
          </TextualData>
          {!isMobile && <Img src={photo ?? avatar} />}
        </PatientData>
        <Spacer top={20} />
        <Content>
          <Menu isMobile={isMobile}>
            <ButtonMenu
              onClick={() => {
                setOptionMenu(1);
                dispatch(medicalRecordAction.handleActive(1));
              }}
              selected={optionMenu === 1}
            >
              Lista de Problemas
            </ButtonMenu>
            <ButtonMenu
              onClick={() => {
                setOptionMenu(2);
                dispatch(medicalRecordAction.handleActive(2));
              }}
              selected={optionMenu === 2}
            >
              Registro de Atendimentos
            </ButtonMenu>
            <ButtonMenu
              onClick={() => {
                setOptionMenu(3);
                dispatch(medicalRecordAction.handleActive(3));
              }}
              selected={optionMenu === 3}
            >
              Linhas de Cuidado
            </ButtonMenu>

            {/*  MOSTRAR APENAS QUANDO NÃO É DEPENDENTE*/}
            {
              !dependenteProfile && (
                <>
                  <ButtonMenu
                    onClick={() => {
                      setOptionMenu(4);
                      dispatch(medicalRecordAction.handleActive(4));
                    }}
                    selected={optionMenu === 4}
                  >
                    Saúde Ocupacional
                  </ButtonMenu>
                </>
              )
            }

            {useClinicFrame && ultimoProntuario?.data?.data?.clinicFrameId && clinicFrameConfig &&
              <ButtonMenu
                onClick={() => {
                  const url = clinicFrameConfig.url;
                  const params = clinicFrameConfig.urlParamsReceituario || "p=H";
                  window.open(`${url}${url.includes('?') ? '&' : '?'}${params}&a=${ultimoProntuario.data.data.clinicFrameId}`, '_blank');
                }}
                selected={optionMenu === 8}
              >
                Receituário Eletrônico
                &nbsp;<BiLinkExternal />
              </ButtonMenu>
            }
            <ButtonMenu
              onClick={() => {
                setOptionMenu(7);
                dispatch(medicalRecordAction.handleActive(7));
              }}
              selected={optionMenu === 7}
              color={allergiesColor}
            >
              Alergias
            </ButtonMenu>
            <ButtonMenu
              onClick={() => {
                setOptionMenu(6);
                dispatch(medicalRecordAction.handleActive(6));
              }}
              selected={optionMenu === 6}
            >
              Exames
            </ButtonMenu>
            <ButtonMenu
              onClick={() => {
                setOptionMenu(5);
                dispatch(medicalRecordAction.handleActive(5));
              }}
              selected={optionMenu === 5}
            >
              Questionários
            </ButtonMenu>
            <ButtonMenu
              onClick={() => {
                setOptionMenu(9);
                dispatch(medicalRecordAction.handleActive(9));
              }}
              selected={optionMenu === 9}
            >
              Termos
            </ButtonMenu>
          </Menu>
          {select(optionMenu)}
        </Content>
      </GeneralContainer>
    </ContainerWithSidebar >
  );
}

export default MedicalRecord;
